import React, { useState, useEffect } from 'react';
import './styles.css'
import CardFriend from './CardFriend';
import Spinner from 'react-spinner-material';


import * as firebase from 'firebase';

export default function FriendsList({ history }) {

    const [idFriends, setIdFriends] = useState([]);
    const [photoFriends, setPhotoFriends] = useState([]);
    const [nameFriends, setNameFriends] = useState([]);
    const [resultNameFriends, setResultNameFriends] = useState([]);
    const [resultNumberFriends, setResultNumberFriends] = useState([]);
    const [qtComments, setQtComments] = useState([]);
    const [qtLikes, setQtLikes] = useState([]);
    const [finishReadFriends, setFinishReadFriends] = useState(false)

    var arrIdFriends = []
    var arrPhotoFriends = []
    var arrNameFriends = []
    var arrResultNameFriends = []
    var arrResultNumberFriends = []
    var arrQtComments = []
    var arrQtLikes = []

    useEffect(() => {
        if (localStorage.getItem("userId") != '' && localStorage.getItem("userId") !== undefined && localStorage.getItem("userId") !== null) {
            console.log(finishReadFriends)
            if (!finishReadFriends) {
                showFriends()
            }
        } else {
            history.push('/home')
        }
    }, [finishReadFriends])

    async function showFriends() {
        await getFriends()
    }

    async function getFriends() {
        try{
        await window.FB.api(
            `/${localStorage.getItem("userId")}/friends?access_token=${localStorage.getItem("token")}`,
            'GET',
            {},
            function (response) {
                var index = 0;
                response.data.map(friend => {
                    firebase.database().ref('/usuarios/' + friend.id).once('value').
                        then(function (snapshot) {
                            if (snapshot != null && snapshot.val() != null) {
                                console.log(snapshot.val())
                                var feito = snapshot.val().resultado.feito || false;
                                if (feito) {
                                    arrIdFriends.push(snapshot.val().id || "")
                                    arrPhotoFriends.push(snapshot.val().imagemPerfil || "")
                                    arrNameFriends.push(snapshot.val().nome || "")
                                    arrResultNameFriends.push(snapshot.val().resultado.resultadoPerfilNome || "")
                                    arrResultNumberFriends.push(snapshot.val().resultado.resultadoPerfilNumero || "")
                                    arrQtComments.push(snapshot.val().qtComments || 0)
                                    arrQtLikes.push(snapshot.val().qtLikes || 0)
                                }
                            }

                            if (response.data.length == index + 1) {
                                setIdFriends(arrIdFriends)
                                setPhotoFriends(arrPhotoFriends)
                                setNameFriends(arrNameFriends)
                                setResultNameFriends(arrResultNameFriends)
                                setResultNumberFriends(arrResultNumberFriends)
                                setQtComments(arrQtComments)
                                setQtLikes(arrQtLikes)
                                setFinishReadFriends(true)
                            }
                            index++;
                        })
                })
            }
        );
        }catch{
            history.push('/home')
        }
    }

    function showFriendResult(friendId) {
        history.push({
            pathname: '/friendResult',
            state: {friendId: friendId}
        })
    }

    function goToHome(){
        history.push('/home')
    }

    const items = idFriends.map((item, index) => {
        return (<li key={item} className='space-between-cards' onClick={() => showFriendResult(item)}>
            <CardFriend
                image={photoFriends[index]}
                name={nameFriends[index]}
                perfil={`${resultNumberFriends[index]}. ${resultNameFriends[index]}`}
                comments={qtComments[index]}
                likes={qtLikes[index]}>
            </CardFriend>
        </li>)
    });

    return (
        <div>
            <div onClick={goToHome} className='container-arrow'>
                <i className="left"></i>
                <p className='text-back'>Voltar</p>
            </div>
            <p className="result"> AMIGOS </p>
            <span className='spinner' id='load'>
                <Spinner size={60} spinnerColor={"#449AE2"} visible={!finishReadFriends} />
            </span>
            <ul>{items}</ul>
        </div>
    )
}